export default __webpack_public_path__ + "static/Barlow-Regular-e7eb634d040a6f3840336c988c10b188.ttf";